/**
 * Upload Wrapper - Switches between old and new upload systems
 */
import { uploadLargeFile as uploadLargeFileOld } from 'utils/uploadUtils';
import { UPLOAD_CONFIG } from '../Config/uploadConfig';
import { uploadLargeFileNew } from './uploadManagerNew';

/**
 * Unified upload function that uses feature flag to switch between implementations
 */
export async function uploadLargeFile(options) {
  if (UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM) {
    console.log('[Upload] Using NEW upload system - ');
    return uploadLargeFileNew(options);
  }

  console.log('[Upload] Using LEGACY upload system');
  // Legacy system expects draft_id (underscore), new system uses draftId (camelCase)
  // Transform parameter for backward compatibility
  const legacyOptions = {
    ...options,
    draft_id: options.draftId || options.draft_id,
  };
  return uploadLargeFileOld(legacyOptions);
}

export default uploadLargeFile;
